const featureItems = [
  {
    id: 1,
    icon: 'ri-download-cloud-2-line',
    title: '高速批量下载',
    description: '支持51漫画免费版下载全集一键缓存，采用多线程加速技术，百话漫画数分钟内即可完成离线存储，随时随地畅享51漫画下载资源的极速体验。',
  },
  {
    id: 2,
    icon: 'ri-smartphone-line',
    title: '多端无缝同步',
    description: '51漫画APP覆盖Android、iOS及桌面端，阅读进度与书签云端实时同步。手机看一半换平板继续看，51漫画下载记录全设备共享，体验永不中断。',
  },
  {
    id: 3,
    icon: 'ri-shield-check-line',
    title: '安全纯净体验',
    description: '全站无弹窗广告、无恶意捆绑，HTTPS加密传输保护隐私安全。51漫画免费版下载文件多重扫描确保无毒无害，专注为漫画爱好者提供纯净阅读环境。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            平台优势
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            为什么500万+读者选择5151漫画网进行51漫画下载
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featureItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-2xl p-7 md:p-8 border border-background-200/60 hover:border-primary-200 transition-all text-center"
            >
              <div className="w-14 h-14 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-primary-100 group-hover:bg-primary-200/70 transition-colors">
                <i className={`${item.icon} text-primary-600 text-2xl`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-900 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}